/* eslint-disable max-len */
import React from 'react';

const NewShevronUp: React.FC = (): React.JSX.Element => {
	return (
		<svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
			<path fillRule="evenodd" clipRule="evenodd" d="M13.8047 10.7481C13.5444 11.0084 13.1223 11.0084 12.8619 10.7481L8 5.8862L3.1381 10.7481C2.8777 11.0084 2.4556 11.0084 2.1953 10.7481C1.9349 10.4877 1.9349 10.0656 2.1953 9.80529L8 4.0006L13.8047 9.80529C14.0651 10.0656 14.0651 10.4877 13.8047 10.7481Z" fill="#2C305E"/>
		</svg>
	);
};

export default NewShevronUp;